import React from 'react';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const Product = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "19",
    height: "19",
    viewBox: "0 0 25 24"
  }, props),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement(
    "filter",
    {
      id: "prefix__a",
      width: "179.2%",
      height: "215.2%",
      x: "-39.6%",
      y: "-57.6%",
      filterUnits: "objectBoundingBox"
    },
    /* @__PURE__ */ React.createElement("feOffset", { in: "SourceAlpha", result: "shadowOffsetOuter1" }),
    /* @__PURE__ */ React.createElement("feMorphology", { in: "SourceAlpha", radius: "1", result: "shadowInner" }),
    /* @__PURE__ */ React.createElement("feOffset", { in: "shadowInner", result: "shadowInner" }),
    /* @__PURE__ */ React.createElement(
      "feComposite",
      {
        in: "shadowOffsetOuter1",
        in2: "shadowInner",
        operator: "out",
        result: "shadowOffsetOuter1"
      }
    ),
    /* @__PURE__ */ React.createElement("feGaussianBlur", { in: "shadowOffsetOuter1", result: "shadowBlurOuter1", stdDeviation: "2.5" }),
    /* @__PURE__ */ React.createElement("feColorMatrix", { in: "shadowBlurOuter1", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" })
  ), /* @__PURE__ */ React.createElement("path", { id: "prefix__b", d: "M0 4.737L18.947 4.737 17.763 17.763 1.184 17.763z" })),
  /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", transform: "translate(3.193 2.526)" }, /* @__PURE__ */ React.createElement("use", { fill: "currentColor", filter: "url(#prefix__a)", xlinkHref: "#prefix__b" }), /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "square",
      d: "M18.4 5.237H.548L1.64 17.263h15.666L18.4 5.237z"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "nonzero",
      stroke: "currentColor",
      d: "M5.921 4.737v-.948C5.921 1.697 7.511 0 9.474 0c1.962 0 3.552 1.697 3.552 3.79v.947"
    }
  ))
);

export { Product as default };
//# sourceMappingURL=Product.js.map
